/**
 * Bootstrap function for rtLogService
 *
 * This module provides a reusable initialization function for the rtLogService
 * that can be used by both web and mobile applications.
 */
import { rtLogService } from '@rammetec/core';
/**
 * Bootstraps the rtLogService with an HTTP (or durable) transport.
 *
 * @example
 * ```typescript
 * bootstrapLogService({
 *   transport,
 *   app: 'sc-console',
 *   appVersion: '1.0.0',
 *   getContext: () => ({ orgId }),
 *   persist: true,
 * });
 * ```
 */
export function bootstrapLogService(options) {
    rtLogService.init({
        transport: options.transport,
        app: options.app,
        appVersion: options.appVersion,
        getContext: options.getContext,
        persist: options.persist,
        isDev: options.isDev,
    });
}
//# sourceMappingURL=bootstrapLogService.js.map